import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Cloud = createReactComponent("Cloud", ["svg", defaultAttributes, [["path", {
  d: "M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z",
  key: "1xwwv6"
}]]]);
export default Cloud;